// Parse an SRT file content into plain text (joined lines, cues separated).
export function parseSRT(content) {
  if (!content) return "";
  const blocks = content.replace(/\r/g, "").split(/\n\s*\n/);
  const lines = [];
  for (const block of blocks) {
    const rows = block.split("\n").filter((r) => r.trim() !== "");
    if (rows.length === 0) continue;
    // drop index line and timestamp line
    let start = 0;
    if (/^\d+$/.test(rows[0].trim())) start = 1;
    if (rows[start] && rows[start].includes("-->")) start += 1;
    const text = rows.slice(start).join(" ").trim();
    if (text) lines.push(text);
  }
  return lines.join("\n");
}
